import React from "react";

interface WaiveraLogoLetterProps {
  /** Tailwind classes for responsive sizing (perfect for mobile!) */
  className?: string;
}

export function WaiveraLogoLetter({
  className = "w-auto h-8 max-w-full", // default = same as your original
}: WaiveraLogoLetterProps) {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="33"
      height="35"
      viewBox="0 0 33 35"
      fill="none"
    >
      {/* Double decorative underlines (adapt to theme) */}
      <path
        d="M1.16211 29.2269H31.6504"
        stroke="currentColor"
        strokeWidth="2.32421"
        strokeLinecap="round"
      />
      <path
        d="M6.21826 33.4943H26.8628"
        stroke="currentColor"
        strokeWidth="2.32421"
        strokeLinecap="round"
      />

      {/* Signature wavy "W" with your brand gradient */}
      <path
        d="M1.56982 8.95131C1.56982 8.95131 5.0867 23.4753 9.41609 23.2389C13.7455 23.0026 21.9232 10.2371 20.7206 5.27271C19.518 0.308349 14.467 0.308349 13.505 5.27271C12.5428 10.2371 21.4421 23.4753 24.3284 23.2389C27.2147 23.0026 30.2884 16.6702 31.7846 8.95131"
        stroke="url(#paint0_linear_593_8193)"
        strokeWidth="3.09895"
        strokeLinecap="round"
        fill="none"
      />

      <defs>
        <linearGradient
          id="paint0_linear_593_8193"
          x1="16.752"
          y1="1.54944"
          x2="16.752"
          y2="23.2421"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.245234" stopColor="#A640DA" />
          <stop offset="0.567368" stopColor="#FF6FBC" />
          <stop offset="1" stopColor="#FFD45C" />
        </linearGradient>
      </defs>
    </svg>
  );
}